<template lang="pug">
  .board
    .board_list(v-bind:class="{'board_list-bargraph': is_bargraph}")
      .board_item.board_item-map
        d3map
      .board_item.board_item-bargraph
        bargraph

</template>
<script>
  import {mapState} from 'vuex';
  
  import D3Map from './d3_map.vue';
  import BarGraph from './bargraph.vue';

  export default{
    computed: {
      ...mapState([
        'selected',
        'previous_mode',
      ]),
      is_bargraph(){
        return this.selected.mode == 'bargraph' || (this.selected.mode == 'linegraph' && this.previous_mode == 'bargraph');
      }
    },
    components: {
      d3map: D3Map,
      bargraph: BarGraph
    }
  }
</script>
<style lang="sass">
  .board
    overflow: hidden
    height: 100%
    &_list
      display: flex
      width: 200%
      height: 100%
      transition: transform .3s ease-in-out
      &-bargraph
        transform: translate(-50%, 0)
    &_item
      width: 50%
      height: 100%
      &-map
      &-bargraph
</style>
